export default __webpack_public_path__ + "c20d916c1a1b094c1cec7de61e470633.woff";